import { Button, Image, UIHeading4, UIText1 } from '@cian/ui-kit';
import * as React from 'react';

import * as styles from './YmapsBlockedStub.css';
import icon from './icon-error.svg';

export const YMAPS_BLOCKED_STUB_TEST_ID = 'YmapsBlockedStub';

/** Заглушка на месте карты, когда скрипт Яндекс карт заблокировал антивирус или блокировщик рекламы */
export const YmapsBlockedStub: React.FC = () => {
  return (
    <div className={styles['wrapper']} data-testid={YMAPS_BLOCKED_STUB_TEST_ID}>
      <div className={styles['icon']}>
        <Image src={icon} width={64} height={64} />
      </div>
      <div className={styles['message']}>
        <div className={styles['title']}>
          <UIHeading4 textAlign="center">Карта не загрузилась</UIHeading4>
        </div>
        <UIText1 textAlign="center" color="text-secondary-default">
          Выключите антивирус или блокировку рекламы и&nbsp;обновите страницу
        </UIText1>
      </div>
      <Button size="M" theme="fill_primary" onClick={() => window.location.reload()}>
        Обновить
      </Button>
    </div>
  );
};
